/* global SunergoPlatform */

const initClearField = () => {
	SunergoPlatform.actionButtons.addAction(function(action, button, e) {
		if (action !== 'clear-field') return false;
		e.preventDefault();

		const field = button.closest('[data-field-id]');
		if (!field) return true;

		const input = field.querySelector(SunergoPlatform.inputElements);
		input.value = '';
		input.focus();

		return true;
	});
};

export default initClearField;